import { forwardRef } from "react";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";
import MKInputRoot from "../MKInputRoot";

const MKMoneyInput = forwardRef(({
  error,
  disabled,
  currency,
  decimalScale,
  onRawValueChange,
  ...rest
}, ref) => {

  return (
    <NumericFormat
      {...rest}
      getInputRef={ref}
      customInput={MKInputRoot}
      thousandSeparator=" "
      decimalSeparator="."
      prefix={currency}
      decimalScale={decimalScale}
      fixedDecimalScale
      allowNegative={false}
      onValueChange={({ floatValue }) => onRawValueChange(floatValue)}
      ownerState={{ error, disabled }}
    />
  );
})

// Setting default values for the props of MKMoneyInput
MKMoneyInput.defaultProps = {
  error: false,
  disabled: false,
  currency: "R ",
  decimalScale: 2,
  onRawValueChange: () => { },
};

// Typechecking props for the MKMoneyInput
MKMoneyInput.propTypes = {
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  currency: PropTypes.string,
  decimalScale: PropTypes.number,
  onRawValueChange: PropTypes.func,
};

export default MKMoneyInput;
